import { useAppTheme } from '@droplet-tech-code/core-elements/module/theme';
import { Divider } from '@droplet-tech-code/core-elements/module/ui/Divider/Divider';
import { useSearchState } from '@droplet-tech-code/core-elements/module/ui/Search/Search';
import { VStack } from '@droplet-tech-code/core-elements/module/ui/Stack';
import { isNativeMobile } from '@droplet-tech-code/core-elements/module/utils/utils.helper';
import { LocationListItemResponse } from '@naus-code/naus-admin-types';
import { useCallback, useRef } from 'react';
import { RefreshControl } from 'react-native';

import { FlatList } from '~/components/FlatList/FlatList';
import { useItemSeparatorComponent } from '~/components/FlatList/FlatList.Common';
import { useAppNavigation } from '~/hooks/nav.hook';
import { translate } from '~/utils/translation.utils';

import { PortLocationListHeader } from './PortLocation.ListHeader';
import { PortLocationListItemComponent } from './PortLocation.ListItem';
import { portLocationApi } from './PortLocations.api';

export interface PortLocationListProps {
  onPress: (item: LocationListItemResponse) => void;
}

export const PortLocationListNative = () => {
  const navigate = useAppNavigation();
  return (
    <PortLocationList
      onPress={(item) => {
        navigate.navigate('PortLocation-Item', {
          id: item.id,
        });
      }}
    />
  );
};

export const PortLocationList = (props: PortLocationListProps) => {
  const { list, Search, isLoading, isFetching, refetch } = useSearchState({
    hook: portLocationApi.useGetPortLocationListQuery,
    style: {
      height: 47,
    },
  });

  const selectedRef = useRef('');

  const { spacing } = useAppTheme();

  const renderItem = useCallback((portLocation: LocationListItemResponse) => {
    return (
      <PortLocationListItemComponent key={portLocation.id} portLocation={portLocation} />
    );
  }, []);

  const ItemSeparatorComponent = useItemSeparatorComponent();

  return (
    <VStack flex={1}>
      <PortLocationListHeader />
      {Search}
      <Divider />
      <FlatList
        refreshControl={
          <RefreshControl refreshing={isFetching} onRefresh={() => refetch()} />
        }
        contentContainerStyle={[
          {
            paddingTop: spacing[2.5],
          },

          isNativeMobile && { paddingHorizontal: spacing[2] },
        ]}
        feedback={translate('portLocations.emptyPortLocations')}
        isLoading={isLoading}
        data={list}
        renderItem={renderItem}
        onPressItem={(v) => {
          selectedRef.current = v.id;
          props.onPress(v);
        }}
        ItemSeparatorComponent={ItemSeparatorComponent}
      />
    </VStack>
  );
};
